import { resolveLanguage, type LanguageCode } from '@kairelo/shared';

/**
 * The visitor's language.
 *
 * A visitor has no account, so there is nowhere on the server to keep this —
 * and putting it there would be worse anyway, since it would be one more thing
 * the server knows about someone who never registered. It lives in this browser
 * only: the browser's own language is used until the visitor picks another, and
 * the choice then sticks for as long as the browser keeps it.
 *
 * It governs both the interface and the language messages are translated into,
 * which is the same contract the owner's `preferredLanguage` has.
 */

const STORAGE_KEY = 'tc.visitor-language';

export function loadVisitorLanguage(): LanguageCode {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) return resolveLanguage(stored);
  } catch {
    // Private modes and blocked storage: fall through to the browser's own.
  }
  return resolveLanguage(navigator.language);
}

export function saveVisitorLanguage(language: LanguageCode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // The choice still applies to this page; it just will not survive a reload.
  }
}
